import superagent from 'superagent';
import config from '../config';

const methods = ['get', 'post', 'put', 'patch', 'del'];

function getCookieValue(cookieHeader, name) {
  if (!cookieHeader) return undefined;
  const parts = String(cookieHeader).split(';');
  for (let i = 0; i < parts.length; i += 1) {
    const part = parts[i].trim();
    if (!part) continue;
    const eq = part.indexOf('=');
    if (eq === -1) continue;
    const k = part.slice(0, eq).trim();
    if (k !== name) continue;
    return decodeURIComponent(part.slice(eq + 1));
  }
  return undefined;
}

function getBrowserCookieValue(name) {
  if (typeof document === 'undefined') return undefined;
  return getCookieValue(document.cookie, name);
}

function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? '/' + path : path;
  if (__SERVER__) {
    // Prepend host and port of the API server to the path.
    return 'http://' + config.apiHost + ':' + config.apiPort + adjustedPath;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  return '/api' + adjustedPath;
}

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */
class _ApiClient {
  constructor(req) {
    methods.forEach((method) =>
      this[method] = (path, { params, data, attach, field } = {}) => new Promise((resolve, reject) => {
        const request = superagent[method](formatUrl(path));

        if (params) {
          request.query(params);
        }

        if (__SERVER__ && req.get('cookie')) {
          request.set('cookie', req.get('cookie'));
        }

        if (method !== 'get') {
          const csrfToken = __SERVER__
            ? getCookieValue(req && req.get && req.get('cookie'), 'XSRF-TOKEN')
            : getBrowserCookieValue('XSRF-TOKEN');

          if (csrfToken) {
            request.set('X-XSRF-TOKEN', csrfToken);
          }
        }

        if (attach) {
          attach.foreach(item => request.attach(item.key, item.value));
        }

        if (data) {
          request.send(data);
        }


        if (field) {
          field.forEach(item => request.field(item.key, item.value));
        }

        if (__SERVER__) {
          request.timeout({ response: 9000, deadline: 15000 });
        }

        request.end((err, { body } = {}) => {

          if (err) {
            reject(body || err)
          } else {
            resolve(body)
          }
        })
      }));
  }
}

const ApiClient = _ApiClient;

export default ApiClient;
